var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182.99 179.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a8c0;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:11px;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 91.5,
    cy: 90,
    rx: 91.5,
    ry: 90
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.82,110.43c0,22.9-18.28,41.46-40.82,41.46s-40.83-18.56-40.83-41.46S66.45,69,89,69,129.82,87.53,129.82,110.43Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "56.51 42.19 75.77 42.19 84.31 64.82 84.31 66.96 81.02 65.78 56.51 40.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "121.09 41.57 101.83 41.57 93.3 64.77 93.3 66.96 96.58 65.75 121.09 40.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "66.58 22.97 74.24 38.73 56.51 38.73 66.58 22.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "109.69 22.97 119.54 38.73 103.35 38.73 109.69 22.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "91.09 22.97 107.5 22.97 100.94 38.73 91.09 22.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "86.49 22.97 70.08 22.97 76.64 38.73 86.49 22.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "88.65 22.09 99.3 38.73 79.27 38.73 88.65 22.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "79.27 42.23 99.3 42.23 90.21 66.41 86.49 66.41 79.27 42.23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon11.373ebfbd54f04eada529333d32691dfb.svg";
export { ForwardRef as ReactComponent };